import { SpecialAttackSkill, PhysicalAttackSkill, StatusSkill } from "../../core/skill";
import { Effect, RoundEffect } from "../../core/effect";
import { Timing } from "../../core/timing";

import * as type from "../../core/type";
import * as cond from "../../core/cond";
import * as effect from "../../core/effect";
import * as state from "../../core/state";
import * as pred from "../../core/pred";

/** 瞬念袭：消除回合类效果成功后追加害怕判定。 */
export const 瞬念袭 = new SpecialAttackSkill(
    "瞬念袭",
    type.普通,
    [
        "消除对手的回合类效果，消除成功则100%令对手害怕",
        "命中后有15%的几率秒杀对手，未触发则使对手2回合内无法使用属性技能",
    ],
    85,
    [
        new Effect(new effect.消除回合(), Timing.onDamage, undefined, [
            new Effect(new effect.施加异常状态(new state.害怕()), Timing.triggered),
        ]),
        new Effect(new effect.秒杀(), Timing.onDamage, cond.百分之x的几率(15)),
    ],
    3,
    false,
    1,
    5,
);

export const 重击踩踏 = new PhysicalAttackSkill(
    "重击踩踏",
    type.普通,
    [
        "无视对手免疫伤害效果",
        "消除对手的能力提升效果，消除成功则对手3回合内无法通过技能恢复体力",
        "若对手不处于能力提升状态，则造成的伤害提升100%",
    ],
    110,
    [new Effect(new effect.消除强化(), Timing.onDamage)],
    2,
    true,
    1,
    5,
);

export const 神力封印 = new StatusSkill(
    "神力封印",
    [
        "使对手攻击、特攻等级-3，防御、特防等级-2、速度、命中等级-1",
        "2回合内，对手无法主动切换精灵",
        "3回合内，对手无法免疫异常状态",
        "3回合内，对手减免固定伤害、百分比伤害的效果失效",
    ],
    [
        new Effect(
            new effect.属性下降({
                pAtk: -3,
                mAtk: -3,
                pDef: -2,
                mDef: -2,
                speed: -1,
                hit: -1,
            }),
            Timing.onSkillHit,
        ),
    ],
    1,
    5,
);

export const 愤怒巨岩 = new StatusSkill(
    "愤怒巨岩",
    [
        "4回合内，若受到攻击则100%令对手石化，未触发则消除对手的回合类效果",
        "3回合内，若对手使用属性技能，则其下2回合内无法使用攻击技能",
        "若对手不处于异常状态，则吸取对手最大体力的1/3",
        "为自身创造一个等同于自身最大体力的40%的护盾（不可叠加）",
        "3回合内，每回合都能附加等同于自身护盾值的固定伤害",
    ],
    [],
);

export const 尖峰号角 = new SpecialAttackSkill(
    "尖峰号角",
    type.普通,
    [
        "消除对手的能力提升效果，消除成功则50%令对手失明，未触发则令对手下1回合攻击技能无效",
        "2回合内，若击败对手则免疫下1次受到的攻击",
    ],
    130,
    [new Effect(new effect.消除强化(), Timing.onDamage)],
    0,
    false,
    1,
    5,
);

export const 山神护体 = new StatusSkill(
    "山神护体",
    [
        "全属性+1，后出生时强化效果翻倍",
        "4回合内，每回合附加自身最大体力的40%的百分比伤害并恢复等量体力",
        "4回合内，免疫并反弹异常状态",
        "4回合内，不受能力下降效果影响",
    ],
    [
        new Effect(
            new effect.强化(1, cond.若后出手),
            Timing.onSkillHit
        ),
        new RoundEffect(
            Timing.onSkillHit,
            4,
            new effect.固伤·回血(pred.自身最大体力的百分之x(40)),
            Timing.actionEnd,
            undefined,
            false,
            [],
        ),
    ],
    0,
    5,
);

/** 炫彩神力：消除回合类效果成功后追加害怕判定。 */
export const 炫彩神力 = new SpecialAttackSkill(
    "炫彩神力",
    type.普通,
    [
        "无视对手免疫伤害效果",
        "消除对手的回合类效果，消除成功则100%令对手害怕，未触发则己方免疫下1次受到的异常状态",
        "若当回合未击败对手，则回合结束时吸取对手最大体力的1/3",
    ],
    150,
    [
        new Effect(new effect.消除回合(), Timing.onDamage, undefined, [
            new Effect(new effect.施加异常状态(new state.害怕()), Timing.triggered),
        ]),
    ],
    0,
    true,
    1,
    5,
);
